import { useLocation, Link } from 'react-router-dom'
import { ArrowLeft, ChevronRight } from 'lucide-react'

// Maps route segments to human-readable labels
const routeLabels: Record<string, string> = {
  dashboard: 'Dashboard',
  products: 'Products',
  components: 'Components',
  checklists: 'Checklists',
  suppliers: 'Suppliers',
  documents: 'Documents',
  'supply-chain': 'Supply Chain',
  qms: 'QMS',
  actions: 'Actions',
  objectives: 'Objectives',
  metrics: 'Metrics',
  mrm: 'Management Reviews',
  audits: 'Audits',
  'external-audits': 'External Audits',
  compliance: 'Compliance',
  ncrs: 'Non-Conformances',
  improvements: 'Improvements',
  changes: 'Changes',
  team: 'Team',
  settings: 'Settings',
  reports: 'Reports',
  help: 'Help',
}


export function Breadcrumbs() {
  const location = useLocation()
  const segments = location.pathname.split('/').filter(Boolean)

  // Don't show on top-level pages
  if (segments.length <= 1) return null

  // Build breadcrumb items
  const crumbs: { label: string; href: string }[] = []
  let currentPath = ''

  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i]
    currentPath += `/${segment}`

    // If this looks like a UUID (detail page ID), skip it from display
    if (isUUID(segment)) {
      continue
    }

    const label = routeLabels[segment] || segment.charAt(0).toUpperCase() + segment.slice(1)
    crumbs.push({ label, href: currentPath })
  }

  // Only show if we have more than one breadcrumb level
  if (crumbs.length <= 1) return null

  // Find the parent path for back button
  const parentCrumb = crumbs[crumbs.length - 2]

  return (
    <nav className="flex items-center gap-1.5 text-sm text-muted-foreground mb-4" aria-label="Breadcrumb">
      <Link
        to={parentCrumb.href}
        className="flex items-center gap-1 hover:text-foreground transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-certify-600 rounded"
        aria-label={`Back to ${parentCrumb.label}`}
      >
        <ArrowLeft className="h-3.5 w-3.5" />
        <span>{parentCrumb.label}</span>
      </Link>
      <ChevronRight className="h-3 w-3" />
      <span className="text-foreground font-medium" aria-current="page">
        {crumbs[crumbs.length - 1].label}
      </span>
    </nav>
  )
}

function isUUID(str: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(str)
}
